import React from 'react'

const BreathalyzerIcon = ({width = 12, height = 10,...props}) => {
  return (
    <div style={{backgroundColor: '#1D82FF', width: 17, height: 17, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%'}}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        style={{width: width, height: height, paddingRight: 0}}
        viewBox="0 0 8 7"
        fill="none"
        {...props}
      >
        <path
          fill="#fff"
          d="M6.099 4.452c.116.08.26.052.344-.07.4-.565.634-1.34.634-2.133 0-.792-.231-1.574-.634-2.133-.085-.125-.228-.15-.344-.07-.116.08-.134.23-.044.362.344.494.538 1.158.538 1.841s-.2 1.34-.538 1.841c-.087.132-.072.282.044.362ZM4.945 3.616c.103.074.25.051.334-.074.241-.324.385-.802.385-1.292 0-.491-.144-.966-.385-1.296-.084-.122-.23-.147-.334-.07-.128.09-.147.25-.05.381.181.257.285.613.285.985s-.107.725-.285.984c-.093.135-.078.289.05.382ZM.668 6.682h3.924c.49 0 .665-.144.665-.426 0-.828-1.009-1.97-2.627-1.97C1.009 4.287 0 5.429 0 6.257c0 .282.175.426.668.426Zm1.962-2.97c.672 0 1.25-.615 1.25-1.417 0-.792-.582-1.379-1.25-1.379s-1.25.6-1.25 1.385c0 .796.582 1.412 1.25 1.412Z"
        />
      </svg>
    </div>
  )
}

export default BreathalyzerIcon
